import script from "./EditPost.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPost.vue?vue&type=script&setup=true&lang=js"

import "./EditPost.vue?vue&type=style&index=0&id=3523bf6b&lang=scss"

const __exports__ = script;

export default __exports__